import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtilsV2 } from '@shared/utils';
import {
  AccountsApi,
  RequestStrategyEnum,
  type GetPaymentAccountBalanceReportRequest,
  type GetPaymentAccountBalanceReportResponse,
  type WithSignal,
} from '@shared/api';

const getPaymentAccountBalanceReportEffect = createEffect(({ signal, ...request }: WithSignal<GetPaymentAccountBalanceReportRequest> = {}) =>
  AccountsApi.getPaymentAccountBalanceReport(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<{ total: number; data: GetPaymentAccountBalanceReportResponse[] }>({ data: [], total: 0 })
  .on(getPaymentAccountBalanceReportEffect.done, (_, data) =>
    data.result ? { total: data.result.total, data: data.result.data || [] } : { total: 0, data: [] },
  )
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getPaymentAccountBalanceReportEffect.pending, (_, data) => data)
  .on(getPaymentAccountBalanceReportEffect.fail, (_, data) => ApiUtilsV2.abortApiLoadingFailCaseTrigger(data.error))
  .on(getPaymentAccountBalanceReportEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getPaymentAccountBalanceReportEffect, () => null)
  // .on(getPaymentAccountBalanceReportEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getPaymentAccountBalanceReportEffect.fail, () => 'Something went wrong while fetching Accounts Balance. Please try again.')
  .on(getPaymentAccountBalanceReportEffect.done, () => null)
  .reset(clearEvent);

const getPaymentAccountBalanceReportApi = ApiUtilsV2.wrapperApi(getPaymentAccountBalanceReportEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getPaymentAccountBalanceReportApi.cancel());

export const $accountPaymentReportStore = {
  events: {
    getPaymentAccountBalanceReport: getPaymentAccountBalanceReportApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
